<!-- <div class="spinner">
  <div class="rect1" [style.background-color]="color"></div>
  <div class="rect2" [style.background-color]="color"></div>
  <div class="rect3" [style.background-color]="color"></div>
  <div class="rect4" [style.background-color]="color"></div>
  <div class="rect5" [style.background-color]="color"></div>
</div> -->

<div class="loader" [class.invert]="invert">
  <div class="loader-inner ball-pulse">
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>